import React from 'react';
import RootElement from './src/components/root-element';
import "@popperjs/core/dist/umd/popper.min"
import "bootstrap/dist/css/bootstrap.min.css"
import 'animate.css'
import "bootstrap-icons/font/bootstrap-icons.css"
import 'boxicons';
import 'boxicons/css/boxicons.css'
import 'aos/dist/aos.css'
import './src/css/global.css'
import 'font-awesome/css/font-awesome.min.css';
import "bootstrap/dist/js/bootstrap.bundle.min";
import { initializeTracking } from './src/utils/utmTracker';

export const wrapRootElement = ({ element }) => {
    return <RootElement>{element}</RootElement>;
};

// Initialize UTM parameter tracking and Facebook cookie handling on client-side only
export const onClientEntry = () => {
    if (typeof window !== 'undefined') {
        // Initialize all tracking parameter capture
        initializeTracking();
    }
};

// --- Helper Function to Get Cookie ---
const getCookie = (name) => {
    try {
        if (typeof window === 'undefined' || !navigator.cookieEnabled) return null;
        const nameEQ = encodeURIComponent(name) + "=";
        const ca = document.cookie.split(';');
        for (let i = 0; i < ca.length; i++) {
            let c = ca[i].trim();
            if (c.indexOf(nameEQ) === 0) {
                return decodeURIComponent(c.substring(nameEQ.length, c.length));
            }
        }
        return null;
    } catch (error) {
        console.warn(`Error getting cookie ${name}:`, error);
        return null;
    }
};

// --- Function to read COOKIE and push to dataLayer ---
const pushExternalIdToDataLayer = () => {
    if (typeof window !== 'undefined' && window.dataLayer) {
      try {
        const cookieKeyName = 'external_id'; // Use the SAME key name
        const externalId = getCookie(cookieKeyName); // *** Read from COOKIE ***

        if (externalId) {
          // External ID found in cookie, push it to the data layer.
          console.log(`Value found for cookie ${cookieKeyName}, pushing to dataLayer:`, externalId);
          window.dataLayer.push({
            event: 'externalIdReady',
            // Use a consistent DL variable name, even if cookie key is different
            [cookieKeyName]: externalId
            // Or use: [cookieKeyName]: externalId - just be consistent with GTM variable setup
          });
        } else {
          // console.log(`Cookie ${cookieKeyName} not found.`);
          // Optional: push null if needed.
          // window.dataLayer.push({ event: 'externalIdNotReady', l360_external_id: null });
        }
      } catch (error) {
        console.warn('Error accessing cookie or pushing external_id:', error);
      }
    } else if (typeof window !== 'undefined' && !window.dataLayer) {
        console.warn('DataLayer not available yet when trying to push external_id.');
    }
  };


// --- Gatsby API: onRouteUpdate ---
// This runs after route changes, including the initial page load,
// ensuring the check happens on every "page view".
export const onRouteUpdate = ({ location, prevLocation }) => {
    console.log('Route Updated:', location.pathname); // Debugging

    // Push the external ID on every route update
    pushExternalIdToDataLayer();
};